import { Injectable } from "@angular/core";
import { NgbDateStruct, NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { formatDate } from "@angular/common";
import { LanguageChangeService } from "../language-change.service";

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  constructor(private languageChanged: LanguageChangeService) {
    super();
    languageChanged.languageChanged$.subscribe((x) => (this.currentLang = x));
  }

  currentLang = "en-GB";

  readonly DELIMITER = "/";

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    // Month uses zero based indexing
    return date ? formatDate(new Date(date.year, date.month - 1, date.day), "shortDate", this.currentLang) : "";
  }
}
